import { useQuery } from "@tanstack/react-query";
import { getProspectSearchSummary } from "@/app/actions/prospect-search/get/action";
import { QueryKey } from "@/app/vars/QueryKeys";

export function useFetchProspectSearchSummary(
  options: { avatarId?: number; enabled?: boolean } = {},
) {
  const { avatarId, enabled = true } = options;

  return useQuery({
    queryKey: [QueryKey.PROSPECT_SEARCH_SUMMARY, avatarId],
    queryFn: () => getProspectSearchSummary(avatarId!),
    enabled: enabled && !!avatarId,
    staleTime: Infinity,
  });
}
